import { render } from "./shipinhaoaccount.vue?vue&type=template&id=4d0d8bba&scoped=true"
import script from "./shipinhaoaccount.vue?vue&type=script&lang=js"
export * from "./shipinhaoaccount.vue?vue&type=script&lang=js"

import "./shipinhaoaccount.vue?vue&type=style&index=0&id=4d0d8bba&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0d8bba"]])

export default __exports__